import React from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import { 
  FaCheck, 
  FaPhoneAlt, 
  FaEnvelope, 
  FaInstagram, 
  FaLinkedinIn, 
  FaTwitter, 
  FaFacebookF 
} from "react-icons/fa"; // Importing Font Awesome Icons
import "./SafeJobSearchFooter.css";

const footerLinksData = [
  {
    category: "Jobs by Locations",
    links: [
      "Jobs In Bangalore", "Jobs In Delhi", "Jobs In Mumbai", "Jobs In Chennai",
      "Jobs In Hyderabad", "Jobs In Kolkata", "Jobs In Pune", "Jobs In Chandigarh", "Jobs In Lucknow",
    ],
  },
  {
    category: "Jobs by Skill - IT",
    links: [
      "Biotechnology Jobs", "Digital Marketing Jobs", "Graphic Design Jobs",
      "Networking Jobs", "Oracle Jobs", "SEO Jobs", "Software Testing Jobs", "Sql Jobs", "Web Design Jobs",
    ],
  },
  {
    category: "Jobs by Role",
    links: [
      "Air Hostess Jobs", "Accountant Jobs", "Assistant Professor Jobs",
      "Business Analyst Jobs", "Computer Operator Jobs", "Data Analyst Jobs", "Software Engineer Jobs",
    ],
  },
];

const SafeJobSearchFooter = () => {
  return (
    <div className="safe-search-footer-parent">
      <Container>
        {/* UPPER CONTENT: Safe Job Search Info */}
        <section className="info-content-section mb-5">
          <h2 className="main-heading">Safe Job Search</h2>
          <p className="description-paragraph">
            The Company ensures to provide you a safe environment to search jobs
            and manage your career. For a safe and secure web experience, we
            suggest you take a few simple security precautions when evaluating
            job postings and job opportunities that you may receive via
            email/phone.
          </p>
          <p className="description-paragraph">
            It has come to our notice that sometimes few unscrupulous elements
            approach candidates claiming to be our associates or partners and
            charge fees in lieu of job offers. Please note the Company does not
            authorize any agency/partner to collect fees against job offers.
          </p>

          <ul className="guidelines-list">
            <li>
              <FaCheck className="checkmark-icon" /> The Company recommends jobseekers to be alert &amp; verify the legitimacy of such offers
            </li>
            <li>
              <FaCheck className="checkmark-icon" /> Be cautious of any job appointment confirmation without any interview with the prospective employer
            </li>
            <li>
              <FaCheck className="checkmark-icon" /> Verify the URL or web link before sharing any personal / bank account / credit card / or any other sensitive information
            </li>
          </ul>

          <h3 className="sub-heading mt-4">Reporting fraud</h3>
          <p className="description-paragraph">
            If you see a questionable Job Posting or any potential misuse of the
            site or its brand, please report the suspected fraud to the Company
            at <a href="mailto:info@company.com">info@company.com</a>.
          </p>
        </section>

        <hr className="divider-line" />

        {/* MIDDLE CONTENT: Classified SEO Directory Links */}
        <section className="directory-links-section py-4">
          {footerLinksData.map((group, idx) => (
            <Row key={idx} className="mb-3 data-row">
              <Col lg={2} md={3} xs={12} className="category-label-col">
                <span className="category-title">{group.category} :</span>
              </Col>
              <Col lg={10} md={9} xs={12} className="links-list-col">
                <div className="links-inline-wrap">
                  {group.links.map((link, lIdx) => (
                    <span key={lIdx} className="directory-link-item">
                      <a href={`#${link.toLowerCase().replace(/\s+/g, "-")}`}>
                        {link}
                      </a>
                      {lIdx < group.links.length - 1 && (
                        <span className="separator">|</span>
                      )}
                    </span>
                  ))}
                </div>
              </Col>
            </Row>
          ))}
        </section>

        <hr className="divider-line" />

        {/* BOTTOM CONTENT: Utility Bar & Social Links */}
        <footer className="footer-utility-bar py-4">
          <Row className="align-items-center g-4">
            {/* Country Selector Dropdown */}
            <Col md={3} xs={12}>
              <Form.Select
                className="country-selector-dropdown"
                defaultValue="India"
              >
                <option value="India">India</option>
                <option value="US">United States</option>
                <option value="UK">United Kingdom</option>
              </Form.Select>
            </Col>

            {/* Hotlines / Contact details */}
            <Col md={6} xs={12} className="text-md-center">
              <div className="contact-info-wrapper d-flex flex-wrap justify-content-md-center gap-4 align-items-center">
                <span className="d-flex align-items-center gap-2">
                  <FaPhoneAlt className="utility-icon" /> Toll Free No: +91 960 775 5557 / +91 940 570 9042
                </span>
                <span className="d-flex align-items-center gap-2">
                  <FaEnvelope className="utility-icon" /> info@profcymaglobal.com
                </span>
              </div>
            </Col>

            {/* Social Media Circular Buttons */}
            <Col md={3} xs={12} className="text-md-end">
              <div className="social-icons-wrapper d-flex justify-content-md-end gap-2">
                <a href="#instagram" className="social-circle-btn">
                  <FaInstagram />
                </a>
                <a href="#linkedin" className="social-circle-btn">
                  <FaLinkedinIn />
                </a>
                <a href="#twitter" className="social-circle-btn">
                  <FaTwitter />
                </a>
                <a href="#facebook" className="social-circle-btn">
                  <FaFacebookF />
                </a>
              </div>
            </Col>
          </Row>
        </footer>
      </Container>
    </div>
  );
};

export default SafeJobSearchFooter;